// import Button from 'components/Button';
// import { Link } from 'react-router-dom';
import * as S from './styles';

type BannerProps = {
  icon: React.ReactNode;
  text: string;
  button?: React.ReactNode;
  id?: string;
  typeProduct?: string;
  href?: string;
  as?: string;
  target?: string;
  children?: React.ReactNode;
  className?: string;
  style?: any;
};

export const Banner = ({
  // id,
  icon,
  text,
  // button = false,
  // typeProduct,
  style,
  children,
}: BannerProps) => {
  return (
    <S.Wrapper style={style}>
      <div style={{ display: 'flex' }}>
        {icon}
        <p
          dangerouslySetInnerHTML={{ __html: text }}
          className="no-margin-bottom"
        ></p>
      </div>
      {/* {!!button && typeProduct === 'imob' && (
        <Link to={`ChangeOfPlan/${id}`}>
          <Button>Renovar plano</Button>{' '}
        </Link>
      )} */}
      {/* {!!button && typeProduct === 'locacao' && (
        <Link to={`RenewPlan/${id}`}>
          <Button>Renovar plano</Button>{' '}
        </Link>
      )} */}
      {children}
    </S.Wrapper>
  );
};
